import { render } from "./VisaIcon.vue?vue&type=template&id=732676a4"
import script from "./VisaIcon.vue?vue&type=script&lang=js"
export * from "./VisaIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__